import { Avatar, Box, Button, ButtonBase, Typography, useMediaQuery } from '@mui/material';
import { POST_BY_IDS_API, POST_DETAIL_API, WORKS_BY_USERID_API, USER_BY_HANDLENAME_API } from '../../api/endpoint';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axiosInstance from '../../api/axiosConfig';
import comment from '../../assets/comment.png';
import counterInstance from '../../api/counterConfig';
import createAxiosInstance from '../../api/axiosConfig';
import like from '../../assets/like.png';
import style from './style.module.css';
import view from '../../assets/view.png';
import explore_more from '../../assets/ExploreNow.png';
import Loader from '../../components/loader';

const UserWork: React.FC = () => {
  const location = useLocation();
  const { handle } = useParams();
  const { userDetail, userId } = location.state || {};
  const [userWorkData, setUserWorkData] = useState<any>([]);
  const [pageKey, setPageKey] = useState('');
  const [moreData, setMoreData] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');
  const [loading, setLoading] = useState(true);

  const fetchUserWorks = async () => {
    setLoading(true);
    try {
      const axiosInstance = createAxiosInstance(false);
      const searchTerm = handle;

      const userResponse = await axiosInstance.post(USER_BY_HANDLENAME_API, {
        searchTerm
      });
      const id = userId ? userId : userResponse.data.data.uid;
      const response = await axiosInstance.get(`${WORKS_BY_USERID_API}${id}&page=${pageKey}&count=9`);
      if (response.data.page) {
        setPageKey(response.data.page);
      }
      const postIds = response.data.data?.map((item: any) => item.post_id).join(',');

      const works = await axiosInstance.get(`${POST_BY_IDS_API}${postIds}`);
      const reorderedPostData = response.data.data
        .map((item: any) => works.data.data.find((work: any) => work.post_id === item.post_id))
        .filter((post: any) => post !== undefined);

      const counter = await Promise.all(
        reorderedPostData.map(async (item: any) => {
          const postCounter = await counterInstance.get(`${POST_DETAIL_API}/${id}/${item.post_id}`);
          return postCounter;
        })
      );

      const mergedData = reorderedPostData.map((post: any) => {
        const matchingCounter = counter.find((counter) => counter.data?.Item?.post_id?.S === post.post_id);
        const counterItem = matchingCounter ? matchingCounter.data.Item : {};
        return {
          ...post,
          counter: {
            likes: counterItem.likes?.N || '0',
            views: counterItem.views?.N || '0',
            comments: counterItem.comments?.N || '0',
            badge: counterItem.badge?.S || '',
            user_orientation: counterItem.user_orientation?.S || '',
            version: counterItem.version?.N || '0',
            updated_at: counterItem.updated_at?.S || '',
            active: counterItem.active?.N || '0',
            added_by: counterItem.added_by?.S || '',
            type: counterItem.type?.S || '',
            cws: counterItem.cws?.N || '0'
          }
        };
      });

      if (response?.data.data) {
        setUserWorkData((prevUserData: any) => [...prevUserData, ...mergedData]);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    } finally {
      setMoreData(false);
      setLoading(false);
    }
  };

  const handleMore = () => {
    setMoreData(true);
  };

  useEffect(() => {
    fetchUserWorks();
  }, [moreData]);

  return (
    <div>
      <Typography
        style={{
          textAlign: 'center',

          color: 'white',
          fontWeight: 800,
          letterSpacing: isMobile ? 4 : 8,
          marginBottom: 7,
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '48px'
        }}>
        {`${handle?.toUpperCase()}'s WORKS`}
      </Typography>

      {loading && <Loader />}
      <div className={style['grid-container']}>
        {userWorkData && userWorkData.length > 0 ? (
          userWorkData.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className={style['grid-item']}
                style={{ height: isMobile ? '230px' : '400px', width: isMobile ? '250px' : '380px' }}>
                <div className={style['post-img']}>
                  <img
                    alt={'post'}
                    src={`${process.env.REACT_APP_DEFAULT_AVATAR}/${item?.user_id}/WORKS/IMAGES/medium/${item?.files[0]?.name}`}></img>
                  <div>
                    <div className={style['avatar-container']}>
                      <Typography
                        sx={{
                          color: 'white',
                          fontFamily: 'Baloo2',
                          fontSize: isMobile ? '12px' : '18px',
                          fontWeight: 500,
                          padding: '10px 10px 3px 10px',
                          width: '100%',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis'
                        }}>
                        {item.text}
                      </Typography>
                      <Typography
                        sx={{
                          color: 'white',
                          fontFamily: 'Baloo2',
                          padding: '2px 10px 10px 10px',
                          fontSize: isMobile ? '12px' : '22px',
                          fontWeight: 800
                        }}>
                        {`Score ${item.counter.cws}`}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className={style['reactions']}>
                  <div className={style['blurrr']}>
                    <div className={style['actions']}>
                      <img src={view} alt={'view'} />
                      <Typography style={{ padding: '10px' }}>{item.counter.views}</Typography>
                    </div>
                    <div className={style['actions']}>
                      <img src={like} alt={'like'}></img>
                      <Typography style={{ padding: '10px' }}>{item.counter.likes}</Typography>
                    </div>
                    <div className={style['actions']}>
                      <img src={comment} alt={'comment'}></img>
                      <Typography style={{ padding: '10px' }}>{item.counter.comments}</Typography>
                    </div>
                  </div>

                  <img
                    alt={'post'}
                    src={`${process.env.REACT_APP_DEFAULT_AVATAR}/${item?.user_id}/WORKS/IMAGES/medium/${item?.files[0]?.name}`}></img>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ padding: isMobile ? '' : '0 0 10% 0' }}>
            <Typography style={{ fontFamily: 'Baloo2', color: 'white' }}>
              You haven&apos;t created any work yet!
            </Typography>
          </div>
        )}
      </div>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: isMobile ? 2 : 10
        }}>
        {userWorkData && userWorkData.length > 0 && (
          <ButtonBase
            onClick={() => handleMore()}
            sx={{
              width: isMobile ? '20vw' : '15vw',
              height: '8vh'
            }}>
            <img src={explore_more} alt="Explore More" style={{ width: isMobile ? '30vw' : '20vw', height: 'auto' }} />
          </ButtonBase>
        )}
      </Box>
    </div>
  );
};
export default UserWork;
